module.exports = __webpack_public_path__ + "static/media/applelogo.41d32bdb.png";